import { render } from "./App.vue?vue&type=template&id=43390cb8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__